import React, { useMemo } from "react";
import {
  AbilityProvider as CaslAbilityProvider,
  useAbility as useCaslAbility,
  Can,
} from "@casl/react";
import { AppAbility, defineAbilityFor } from "../casl/ability";
import useLocalStorage from "../hooks/useLocalStorage";

export function AbilityProvider({ children }: { children: React.ReactNode }) {
  const [user] = useLocalStorage<any>("user");
  const ability = useMemo(() => defineAbilityFor(user?.role), [user?.role]);

  return <CaslAbilityProvider value={ability}>{children}</CaslAbilityProvider>;
}

export function useAbility(): AppAbility {
  return useCaslAbility<AppAbility>();
}

export { Can };
